module.exports = __webpack_public_path__ + "static/media/kiulu.775e8734.png";